import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';

import { CircularProgress, Divider, Grid } from '@material-ui/core';
import { LICENSE_CHAGES_TYPE, SERVICES_GROUPS } from 'app/config/services';

import AditionalFiles from 'app/components/VehicleForm/AdditionalFiles';
import { DOCUMENT_TYPES } from 'app/utils/constants';
import filesEndpoint from 'app/api/services/filesEndpoint';

const LicenseVehicleDocuments = props => {
  const {
    classes,
    values,
    setFieldValue,
    canEdit,
    loadingVehicleDocs,
    setLoadingVehicleDocs,
  } = props;

  const service = useSelector(state => state.services.details);
  const documentsStoreVehicle = useSelector(state => state.vehicle.licenseVehicleDocuments);
  const inspectedVehicles = useSelector(state => state.vehicle.inspectedVehicles);

  const [documentsVehicleList, setDocumentsVehicleList] = useState([]);
  const [chosenVehicle, setChosenVehicle] = useState({});

  useEffect(() => {
    const init = async () => {
      if (SERVICES_GROUPS.LICENSE.includes(service.cdServico)) {
        setDocumentsVehicleList(documentsStoreVehicle);
      }
    };
    init();
  }, [documentsStoreVehicle, service.cdServico]);

  useEffect(() => {
    const init = async () => {
      setLoadingVehicleDocs(true);
      if (
        values?.cdTipoAlteracaoLicenca &&
        (values.cdTipoAlteracaoLicenca === LICENSE_CHAGES_TYPE.SUBSTITUICAO_VEICULO ||
          values.cdTipoAlteracaoLicenca === LICENSE_CHAGES_TYPE.ALTERAR_PROPRIETARIO_VEICULO ||
          values.cdTipoAlteracaoLicenca === LICENSE_CHAGES_TYPE.MUDANCA_MUNICIPIO_VEICULO)
        //|| values.cdTipoAlteracaoLicenca === LICENSE_CHAGES_TYPE.MUDANCA_RAZAO_SOCIAL
      ) {
        if (documentsVehicleList.length > 0) {
          if (values.licencaVeiculos && values.licencaVeiculos.length > 0) {
            let temp = null;
            let key = '';

            let index = _.findKey(values.licencaVeiculos, o => {
              return o.cdVeiculoAntigo != null || o.cdVeiculoSubstituir != null;
            });
            if (!index || index < 0) index = 0;

            if (values.licencaVeiculos[index].veiculoSubstituir) {
              temp = _.cloneDeep(values.licencaVeiculos[index].veiculoSubstituir);
              key = 'veiculoSubstituir';
            } else if (values.licencaVeiculos[index].veiculo) {
              temp = _.cloneDeep(values.licencaVeiculos[index].veiculo);
              key = 'veiculo';
            }

            if (temp) {
              const found = _.find(inspectedVehicles, ['cdVeiculo', Number(temp.cdVeiculo)]);
              if (found?.documentos) {
                const tempDoc = [...temp.documentos];

                for (const doc of found.documentos) {
                  if (
                    doc.cdTipoDocumento === DOCUMENT_TYPES.CRLV ||
                    doc.cdTipoDocumento === DOCUMENT_TYPES.CERTIFICADO_VISTORIA
                  ) {
                    let tempInt = { ...doc };
                    const key = _.findKey(tempDoc, o => {
                      return o.cdTipoDocumento === doc.cdTipoDocumento;
                    });
                    if (key >= 0) {
                      tempInt = { ...tempInt, ...tempDoc[key] };
                    }

                    if (!tempInt.fileName && tempInt.idFile) {
                      const response = await filesEndpoint.getFileData(tempInt.idFile);
                      if (response.status === 200 && response.data) {
                        tempInt.fileName = response.data.name;
                      }
                    }
                    if (key >= 0) {
                      tempDoc[key] = tempInt;
                    } else {
                      tempDoc.push(tempInt);
                    }
                  }
                }
                temp.documentos = tempDoc;
              }
              const tempLicencaVeiculos = _.cloneDeep(values.licencaVeiculos);
              tempLicencaVeiculos[index][key] = temp;
              setFieldValue('licencaVeiculos', tempLicencaVeiculos);
              setChosenVehicle(temp);
            }
          }
        }
      }
      setLoadingVehicleDocs(false);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentsVehicleList.length, inspectedVehicles]);

  if (loadingVehicleDocs) {
    return (
      <Grid container spacing={3} className={classes.documentsContainer}>
        <Grid item xs={12}>
          <div className={classes.centerProgress}>
            <CircularProgress size={18} />
          </div>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      {Object.keys(chosenVehicle).length > 0 && (
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.divider}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <h3 className={classes.title}>Documentos do veiculo {chosenVehicle.dePlaca}</h3>
          </Grid>
          <AditionalFiles
            {...props}
            valuesFormik={values}
            values={chosenVehicle}
            documentsList={documentsVehicleList}
            dePlaca={chosenVehicle.dePlaca}
            disabled={!canEdit}
            cdVeiculo={chosenVehicle.cdVeiculo}
            contextProps={{ canEdit: canEdit }}
          />
          <Grid item xs={12} className={classes.divider}>
            <Divider />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default LicenseVehicleDocuments;
